import styles from './SkipLink.scss.js';
import { jsx } from 'react/jsx-runtime';

const SkipLink = ({
  children,
  anchorId
}) => {
  return /*#__PURE__*/jsx("a", {
    className: styles.SkipLink,
    href: `#${anchorId}`,
    children: children
  });
}; // eslint-disable-next-line jsx-a11y/anchor-is-valid

const Anchor = ({
  id
}) => /*#__PURE__*/jsx("a", {
  id: id,
  tabIndex: -1
});

SkipLink.Anchor = Anchor;

export { SkipLink };
